import axios from 'axios';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import Cookie from 'js-cookie';
import {getHash} from './HashService';
import requestUtil from './requestUtil';

import {s7PageInit} from "../utils/CDNPageInit";

const frontVersion = FRONTEND_VERSION;
const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;
const adsServicePrefix = `${process.env.REACT_APP_PREFIX_ADS_SERVICE}/api/v1`;

let travelers = {};

const _loadTravelers = () => {
    return new Promise(resolve => {
        requestUtil('/S7WAdsService/api/v1/recommendation/travelers')
            .then((data) => {
                resolve(data);
            });
    });
};

export const loadTravelers = (options) => {
    const key = JSON.stringify(options);

    if (key in travelers) {
        return travelers[key];
    }

    travelers[key] = _loadTravelers();

    return travelers[key];
};

let offersCache = {};

const _loadPartnersOffers = options => {
    return new Promise(resolve => {
        requestUtil(`${adsServicePrefix}/recommendation/offers`, {...options, method: 'POST'})
            .then((data) => {
                resolve(data);
            });
    });
};

export const loadPartnersOffers = options => {
    const key = JSON.stringify(options);

    if (key in offersCache) {
        return offersCache[key];
    }

    offersCache[key] = _loadPartnersOffers(options);

    return offersCache[key];
};

export const _loadPersonalizedBanners = ({ lang, ns, personCookie, place, platform, userAirportCode }) => {
    return new Promise(resolve => {
        const searchParams = new URLSearchParams('');
        searchParams.append('lang', lang);
        searchParams.append('ns', ns);
        searchParams.append('personCookie', personCookie);
        searchParams.append('place', place);
        searchParams.append('platform', platform);
        searchParams.append('userAirportCode', userAirportCode);

        requestUtil(`/S7WAdsService/api/v1/recommendation/diamonds?${searchParams}`)
            .then((data) => {
                resolve(data);
            });
    });
};

const cache = {};

export const loadPersonalizedBanners = options => {
    const { lang, ns, personCookie, place, platform, userAirportCode } = options;
    const key = JSON.stringify(options);

    if (key in cache) {
        return cache[key];
    }

    cache[key] = _loadPersonalizedBanners({ lang, ns, personCookie, place, platform, userAirportCode });

    return cache[key];
};

const _loadAdditionalBanner = ({ lang, personCookie, platform, userAirportCode }) => {
    return new Promise(resolve => {
        const searchParams = new URLSearchParams('');
        searchParams.append('lang', lang);
        searchParams.append('personCookie', personCookie);
        searchParams.append('platform', platform);
        searchParams.append('userAirportCode', userAirportCode);

        requestUtil(`/S7WAdsService/api/v1/recommendation/main/additional?${searchParams}`)
            .then((data) => {
                const { items, hasPersonalized } = data;

                resolve({ items, hasPersonalized });
            });
    });
};

const cacheAdditional = {};

export const loadAdditionalBanner = options => {
    const { lang, personCookie, platform, userAirportCode } = options;
    const key = JSON.stringify(options);
    //
    // if (key in cacheAdditional) {
    //     return cacheAdditional[key];
    // }

    cacheAdditional[key] = _loadAdditionalBanner({ lang, personCookie, platform, userAirportCode });

    return cacheAdditional[key];

};

const cachePlace = {};

const _loadPlaceBanner = ({ lang, ns = 'default', place, platform = 'DESKTOP' }) => {
    return new Promise(resolve => {
        const searchParams = new URLSearchParams('');
        searchParams.append('lang', lang);
        searchParams.append('ns', ns);
        searchParams.append('place', place);
        searchParams.append('platform', platform);

        requestUtil(`/S7WAdsService/api/v1/recommendation/diamonds?${searchParams}`)
            .then((data) => {
                resolve(data);
            }).catch(e => console.log(e))
    });
};

export const loadPlaceBanner = options => {
    const { lang, ns, place, platform } = options;
    const key = JSON.stringify(options);

    if(key in cachePlace) {
        return cachePlace[key];
    }

    cachePlace[key] = _loadPlaceBanner({ lang, ns, place, platform });

    return cachePlace[key];
};

const setSessionID = () => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for ( let i=0; i < 20; i++ ) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    Cookie.set('vlSessionId', text, {expires: 30 / 1440, path: '/', domain: cookieDomain});

    return text;
};

export const getPromoCode = options => {
    const { ruleUid, clearReferer } = options;
    const vlSessionId = Cookie.get('vlSessionId') || setSessionID();
    const referer = clearReferer ? '' : (isNil(window.headerReferer) ? document.referrer : window.headerReferer);
    const sign = getHash(vlSessionId + ':' + Cookie.get('ssdkl') + ':' + ruleUid + ':' + referer + ':get-child');

    return new Promise((resolve,reject) =>
        axios.get(`/S7WAdsService/api/v1/promo/code/get-child`, {
            params: {
                referer: referer,
                ruleUid: ruleUid,
                sessionId: vlSessionId,
                sign: sign,
                requestUid: s7PageInit.requestUid,
                appV: frontVersion,
            }
        }).then((response) => {
            resolve(response)
        }).catch(() => {
            reject();
        })
    );
};

export const logPromoCode = options => {
    const {ruleUid, clearReferer, status} = options;
    const vlSessionId = Cookie.get('vlSessionId') || setSessionID();
    const referer = clearReferer ? '' : (isNil(window.headerReferer) ? document.referrer : window.headerReferer);
    const sign = getHash(vlSessionId + ':' + Cookie.get('ssdkl') + ':' + ruleUid + ':' + referer + ':get-child');

    return new Promise((resolve, reject) =>
        axios.post(`/S7WAdsService/api/v1/promo/code/log-child`, null, {
            params: {
                referer: referer,
                ruleUid: ruleUid,
                sessionId: vlSessionId,
                sign: sign,
                status: status,
                requestUid: s7PageInit.requestUid,
                appV: frontVersion,
            }
        }).then((response) => {
            resolve(response)
        }).catch(() => {
            reject();
        })
    );
};

const _getInstagramContestGallery = ({limit = 20, newFirst = false, winners = false, itemsId = []}) => (
    new Promise((resolve, reject) => {
        axios.post('/S7WAdsService/api/v1/contest/s7-landing/items', itemsId, {
            params: {
                limit,
                newFirst,
                winners,
                appV: frontVersion,
            },
            headers: {'Content-Type': 'application/json'}
        })
            .then(posts => {
                resolve(posts);
            })
            .catch(error => {
                reject(error);
            });
    })
)

const galleryCache = {};

export const getInstagramContestGallery = options => {
    const { limit, newFirst, winners, itemsId } = options;
    const key = JSON.stringify(options);

    if(galleryCache[key]) {
        return galleryCache[key];
    }

    galleryCache[key] = _getInstagramContestGallery({ limit, newFirst, winners, itemsId });

    return galleryCache[key];
}


let b2bPartners = {};

const _loadB2bPartners = options => {
    return new Promise((resolve, reject) =>
        axios
            .get(`${adsServicePrefix}/recommendation/b2b-profi-offers`, {
                params: { ...options },
            })
            .then((response) => {
                resolve(response);
            })
            .catch(() => {
                reject();
            })
    );
};

export const loadB2bPartners = options => {
    const key = JSON.stringify(options);

    if (key in b2bPartners) {
        return b2bPartners[key];
    }

    b2bPartners[key] = _loadB2bPartners(options);

    return b2bPartners[key];
};


const recommendationRoutes = {};

const _loadRecommendationRoutes = ({ currency, lang, userAirportCode, topN, source, profileId }) => {

    const searchParams = new URLSearchParams('');
    searchParams.append('currency', currency);
    searchParams.append('lang', lang);
    searchParams.append('topN', topN);
    searchParams.append('userAirportCode', userAirportCode);
    searchParams.append('source', source);

    if(profileId){
        searchParams.append('profileId', profileId);
    }

    return new Promise((resolve, reject) => {
        requestUtil(`${adsServicePrefix}/recommendation/main/routes?${searchParams}`)
            .then((data) => {
                resolve(data);
            })
            .catch(() => reject());
    });
};

export const loadRecommendationRoutes = options => {
    const { currency, lang, userAirportCode, topN, source, profileId } = options;
    const key = JSON.stringify(options);

    if (key in recommendationRoutes) {
        return recommendationRoutes[key];
    }

    recommendationRoutes[key] = _loadRecommendationRoutes({ currency, lang, userAirportCode, topN, source, profileId });
    return recommendationRoutes[key];
};

export const loadGuidyneData = ({ ruleSetName, platform }) => {
    return new Promise((resolve, reject) => {
        requestUtil(`${adsServicePrefix}/guidyne/rules?ruleSetName=${ruleSetName}&platform=${platform}`)
            .then((data) => {
                resolve(data);
            })
            .catch(() => reject());
    });
};